import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config';
import './TallasVestuario.css';

export default function TallasVestuario({ personaId, onClose }) {
    const [tallas, setTallas] = useState({
        camisa: '',
        pantalon: '',
        zapatos: '',
        casco: '',
        guantes: '',
        chaqueta: ''
    });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        fetchTallas();
    }, [personaId]);

    const fetchWithAuth = async (url, options = {}) => {
        const token = localStorage.getItem('authToken');
        return fetch(url, {
            ...options,
            headers: {
                ...options.headers,
                'Authorization': `Bearer ${token}`
            }
        });
    };

    const fetchTallas = async () => {
        try {
            setLoading(true);
            const response = await fetchWithAuth(`${API_BASE_URL}/api/tallas-vestuario/${personaId}`);
            
            if (response.ok) {
                const data = await response.json();
                if (data && data.id) {
                    setTallas({
                        camisa: data.camisa || '',
                        pantalon: data.pantalon || '',
                        zapatos: data.zapatos || '',
                        casco: data.casco || '',
                        guantes: data.guantes || '',
                        chaqueta: data.chaqueta || ''
                    });
                }
            }
        } catch (err) {
            console.error('Error al cargar tallas:', err);
            setError('Error al cargar tallas');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTallas(prev => ({
            ...prev,
            [name]: value
        }));
        setError('');
        setSuccess('');
    };

    const handleSave = async () => {
        try {
            setSaving(true);
            setError('');
            setSuccess('');

            const response = await fetchWithAuth(`${API_BASE_URL}/api/tallas-vestuario`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id_personal: personaId,
                    ...tallas
                })
            });

            if (response.ok) {
                setSuccess('Tallas guardadas exitosamente');
                setTimeout(() => {
                    if (onClose) onClose();
                }, 1500);
            } else {
                const errorData = await response.json();
                setError(errorData.error || 'Error al guardar tallas');
            }
        } catch (err) {
            console.error('Error al guardar tallas:', err);
            setError('Error al guardar tallas');
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return <div className="modal-overlay"><div className="modal-content"><p>Cargando tallas...</p></div></div>;
    }

    return (
        <div className="modal-overlay" onClick={onClose} style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
        }}>
            <div className="modal-content tallas-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header tallas-modal-header">
                    <h2 className="tallas-modal-title">📏 Tallas de Vestuario</h2>
                    <button 
                        className="close-btn" 
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '24px',
                            cursor: 'pointer',
                            color: '#666'
                        }}
                    >×</button>
                </div>

                <div className="modal-body tallas-modal-body">
                    {error && <div className="error-message" style={{ color: 'red', marginBottom: '15px', padding: '10px', backgroundColor: '#fee' }}>{error}</div>}
                    {success && <div className="success-message" style={{ color: 'green', marginBottom: '15px', padding: '10px', backgroundColor: '#efe' }}>{success}</div>}

                    <div className="tallas-grid">
                        <div className="talla-field">
                            <label>Camisa</label>
                            <input
                                type="text"
                                name="camisa"
                                value={tallas.camisa}
                                onChange={handleChange}
                                placeholder="XS, S, M, L, XL, XXL"
                            />
                        </div>

                        <div className="talla-field">
                            <label>Pantalón</label>
                            <input
                                type="text"
                                name="pantalon"
                                value={tallas.pantalon}
                                onChange={handleChange}
                                placeholder="XS, S, M, L, XL, XXL"
                            />
                        </div>

                        <div className="talla-field">
                            <label>Zapatos</label>
                            <input
                                type="text"
                                name="zapatos"
                                value={tallas.zapatos}
                                onChange={handleChange}
                                placeholder="Número de zapato"
                            />
                        </div>

                        <div className="talla-field">
                            <label>Casco</label>
                            <input
                                type="text"
                                name="casco"
                                value={tallas.casco}
                                onChange={handleChange}
                                placeholder="Talla de casco"
                            />
                        </div>

                        <div className="talla-field">
                            <label>Guantes</label>
                            <input
                                type="text"
                                name="guantes"
                                value={tallas.guantes}
                                onChange={handleChange}
                                placeholder="XS, S, M, L, XL"
                            />
                        </div>

                        <div className="talla-field">
                            <label>Chaqueta</label>
                            <input
                                type="text"
                                name="chaqueta"
                                value={tallas.chaqueta}
                                onChange={handleChange}
                                placeholder="XS, S, M, L, XL, XXL"
                            />
                        </div>
                    </div>
                </div>

                <div className="modal-footer tallas-modal-footer">
                    <button 
                        className="btn-secondary" 
                        onClick={onClose}
                        disabled={saving}
                        style={{
                            padding: '8px 16px',
                            backgroundColor: '#f1f5f9',
                            border: '1px solid #cbd5e1',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        Cancelar
                    </button>
                    <button 
                        className="btn-primary" 
                        onClick={handleSave}
                        disabled={saving}
                        style={{
                            padding: '8px 16px',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        {saving ? 'Guardando...' : 'Guardar Tallas'}
                    </button>
                </div>
            </div>
        </div>
    );
}
